import type { ObjectValues } from '@repo/common';

export const DocumentCaptureStep = {
  FRONT_PAGE: 'FRONT_PAGE',
  REVIEW: 'REVIEW',
  BACK_PAGE: 'BACK_PAGE',
  PROCESSING: 'PROCESSING',
} as const;

export type DocumentCaptureStepValues = ObjectValues<typeof DocumentCaptureStep>;
